import request from "@/utils/request";

export function versions() {
  return request({
    url: "/consumer/release/versionsWeb",
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/version.js